import {LoadingSkeleton} from '@github-ui/skeleton/LoadingSkeleton'
import {ActionList, Box} from '@primer/react'
import type {FC} from 'react'

import styles from './RowLoading.module.css'

type Props = {
  width?: string
  showCompactDensity?: boolean
}

const RowLoading: FC<Props> = ({width = 'random', showCompactDensity = false}) => (
  <ActionList.Item>
    <Box
      sx={{
        alignItems: showCompactDensity ? 'center' : 'flex-start',
        height: showCompactDensity ? '20px' : '40px',
      }}
      className={styles.rowLoadingContainer}
    >
      <LoadingSkeleton variant="elliptical" height="md" width="md" />
      <div className={styles.rowLoadingContent}>
        <LoadingSkeleton variant="rounded" height="sm" width={width} />
        {!showCompactDensity && (
          <LoadingSkeleton variant="rounded" height="12px" width={width} className={styles.LoadingSkeleton} />
        )}
      </div>
    </Box>
  </ActionList.Item>
)

export default RowLoading

try{ RowLoading.displayName ||= 'RowLoading' } catch {}